
export default "/assets/question-mark-circle-mini.43cc862c.svg"